import React, { useState, useEffect } from 'react';
import classes from "../Pages.module.css";
import { Row, Col, Skeleton, Switch, message } from "antd";
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import SalesTable from "./SalesTable";

const ModulesRights = () => {
  const [columns, setColumns] = useState([]);
  const [moduleRows, setModuleRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formColumns, setFormColumns] = useState([]);
  const [formRows, setFormRows] = useState(null);
  const [selectedModule, setSelectedModule] = useState(null);
  const [viewingForms, setViewingForms] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userModules, specCode } = location.state || {};

  useEffect(() => {
    if (userModules) {
      setColumns([
        { name: "SNO", title: "SNo" },
        { name: "module_name", title: "Module Name" },
        { name: "view_forms", title: "Forms Access" }
      ]);

      // Process the module list from the API response format
      let processedData = [];
      
      if (userModules.status === "success" && userModules.data && userModules.data.moudlelist) {
        processedData = userModules.data.moudlelist.rows.map((module, index) => {
          // Store module data
          const moduleData = {
            module_id: module.module,
            module_name: module.get_module
          };
          
          return {
            SNO: index + 1,
            module_name: module.get_module,
            view_forms: "View Forms",
            raw: moduleData
          };
        });
      }

      setModuleRows(processedData);
    }
  }, [userModules]);

  // Handle view forms click
  const handleViewForms = async (moduleId, moduleName) => {
    try {
      setLoading(true);
      setSelectedModule(moduleName);
      
      // API call to get forms for this module
      const response = await axios.get(
        `https://metalzulu-backend.onrender.com/api/v1/dashboardadmin/get-forms/${moduleId}`,
        { withCredentials: true }
      );
      
      if (response.data && response.data.status === "success") {
        console.log("Forms API Response:", response.data);
        
        // Set up columns for forms table
        setFormColumns([
          { name: "SNO", title: "SNo" },
          { name: "form_name", title: "Form Name" },
          // { name: "view_access", title: "View Access" },
          // { name: "edit_access", title: "Edit Access" },
          // { name: "delete_access", title: "Delete Access" }
        ]);
        
        // Process form data based on the API response format
        const processedFormData = response.data.data.Formlist.rows.map((form, index) => {
          return {
            SNO: index + 1,
            form_name: form.form_name,
            view_access: (
              <Switch
                defaultChecked={false}
                onChange={(checked) => handlePermissionChange(index, 'view_access', checked)}
              />
            ),
            edit_access: (
              <Switch
                defaultChecked={false}
                onChange={(checked) => handlePermissionChange(index, 'edit_access', checked)}
              />
            ),
            delete_access: (
              <Switch
                defaultChecked={false}
                onChange={(checked) => handlePermissionChange(index, 'delete_access', checked)}
              />
            ),
            raw: {
              form_id: form.form_id,
              form_name: form.form_name,
              view: false,
              edit: false,
              delete: false
            }
          };
        });
        
        setFormRows(processedFormData);
        setViewingForms(true);
      } else {
        message.error("Failed to fetch forms data");
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      message.error("Failed to fetch forms for this module");
    } finally {
      setLoading(false);
    }
  };

  // Handle permission change for forms
  const handlePermissionChange = (index, field, value) => {
    const updatedRows = [...formRows];
    
    // Update the switch component
    updatedRows[index][field] = (
      <Switch
        checked={value}
        onChange={(checked) => handlePermissionChange(index, field, checked)}
      />
    );
    
    // Update the raw data
    if (field === 'view_access') {
      updatedRows[index].raw.view = value;
    } else if (field === 'edit_access') {
      updatedRows[index].raw.edit = value;
    } else if (field === 'delete_access') {
      updatedRows[index].raw.delete = value;
    }
    
    setFormRows(updatedRows);
  };

  // Save form permissions
  const handleSavePermissions = async () => {
    try {
      setLoading(true);
      
      // Prepare data for saving
      const permissions = formRows.map(row => ({
        form_id: row.raw.form_id,
        view: row.raw.view,
        edit: row.raw.edit,
        delete: row.raw.delete
      }));
      
      // Make API call to save permissions
      await axios.post(
        'https://metalzulu-backend.onrender.com/api/v1/dashboardadmin/update-form-permissions',
        {
          spec_code: specCode,
          module_id: selectedModule.module_id,
          forms: permissions
        },
        { withCredentials: true }
      );
      
      message.success('Form permissions updated successfully');
    } catch (error) {
      console.error("Error saving permissions:", error);
      message.error("Failed to save form permissions");
    } finally {
      setLoading(false);
    }
  };

  // Custom cell formatter for the SalesTable
  const customFormatter = (row, col) => {
    if (col === "view_forms") {
      return (
        <button 
          className={classes["ActionButton"]} 
          onClick={() => handleViewForms(row.raw.module_id, row.raw.module_name)}
        >
          {row[col]}
        </button>
      );
    }
    return row[col];
  };

  // Back to modules list
  const handleBackToModules = () => {
    setViewingForms(false);
    setFormRows(null);
  };

  // Handle back button click
  const handleBack = () => {
    if (viewingForms) {
      handleBackToModules();
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={viewingForms ? 12 : 16}>
          <p className={classes["Title"]}>
            {viewingForms
              ? `Forms Rights for ${selectedModule} - ${specCode}`
              : `Module Rights for ${specCode}`}
          </p>
        </Col>
        <Col className={classes["Col"]} md={viewingForms ? 12 : 8}>
          <Row className={classes["Row"]}>
            {viewingForms && (
              <Col lg={12} md={10}>
                {/* <button
                  onClick={handleSavePermissions}
                  className={classes["SaveButton"]}
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Permissions'}
                </button> */}
              </Col>
            )}
            <Col className={classes["Col"]} lg={12} md={14}>
              <button
                onClick={handleBack}
                className={classes["ProfileButton"]}
              >
                {viewingForms ? "Back to Modules" : "Back"}
              </button>
            </Col>
          </Row>
        </Col>
      </Row>
      <p></p>
      {loading ? (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      ) : viewingForms && formRows ? (
        <SalesTable data={formRows} columns={formColumns} />
      ) : moduleRows ? (
        <SalesTable 
          data={moduleRows} 
          columns={columns} 
          formatter={customFormatter} 
        />
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
}
export default ModulesRights;